import { Icon, Tabs } from '@inflearn/ds-react';
import { KoOnly } from '@inflearn/i18n-tools';
import { faArrowUpRightFromSquare } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import { INFLEARN_URL, MY_URL } from '../../../constants/urls';

import useQueryHandleWithUserId from '../../../hooks/urlQueryString/useQueryHandleWithUserId';
import { useCurrentUrl } from '../../../hooks/useCurrentUrl';

export function MyCoursesTabs({ pathname }: { pathname: string }) {
  const { t } = useTranslation();
  const { currentUrlWithoutQueryString } = useCurrentUrl();
  const { hasUserId, makePathWithUserId } = useQueryHandleWithUserId();

  const isArchivedCourses = pathname.includes(MY_URL.ARCHIVED_COURSES());
  const MY_COURSES_PATH = isArchivedCourses ? MY_URL.ARCHIVED_COURSES() : MY_URL.COURSES();

  const getMyCoursesPath = (path: string) => (hasUserId() ? makePathWithUserId(path) : path);

  // /my/certificates 경로도 수료증 탭을 활성화하도록 처리
  const getTabValue = () => {
    if (currentUrlWithoutQueryString === MY_URL.CERTIFICATES()) {
      return MY_URL.VOUCHERS();
    }
    return currentUrlWithoutQueryString;
  };

  return (
    <Tabs
      styles={{
        tabsList: {
          flexWrap: 'nowrap',
        },
      }}
      value={getTabValue()}
      wrap="nowrap"
      variant="outline"
    >
      <Tabs.List>
        <Tabs.Tab component={Link} value={MY_COURSES_PATH} href={getMyCoursesPath(MY_COURSES_PATH)}>
          {t('강의')}
        </Tabs.Tab>
        <Tabs.Tab component={Link} value={MY_URL.NOTES()} href={getMyCoursesPath(MY_URL.NOTES())}>
          {t('강의 노트')}
        </Tabs.Tab>
        <KoOnly>
          <Tabs.Tab component={Link} value={MY_URL.CLIPS()} href={getMyCoursesPath(MY_URL.CLIPS())}>
            클립
          </Tabs.Tab>
        </KoOnly>
        <KoOnly>
          <Tabs.Tab
            rightSection={<Icon icon={faArrowUpRightFromSquare} color="gray.5" size="xs" />}
            component="a"
            value={INFLEARN_URL.MY_ROADMAPS()}
            href={INFLEARN_URL.MY_ROADMAPS()}
            target="_blank"
          >
            참여 중 로드맵
          </Tabs.Tab>
        </KoOnly>
        <KoOnly>
          <Tabs.Tab
            component={Link}
            value={MY_URL.MENTORINGS()}
            href={getMyCoursesPath(MY_URL.MENTORINGS())}
          >
            멘토링
          </Tabs.Tab>
        </KoOnly>
        <Tabs.Tab
          component={Link}
          value={MY_URL.VOUCHERS()}
          href={getMyCoursesPath(MY_URL.VOUCHERS())}
        >
          {t('수료증')}
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
